import { Component, forwardRef, Input, OnInit, ViewEncapsulation } from '@angular/core';
import { ControlValueAccessor, FormControl, NG_VALUE_ACCESSOR } from '@angular/forms';
import moment from 'moment';

@Component({
  selector: 'app-form-input-text-group',
  standalone: false,
  templateUrl: './form-input-text-group.component.html',
  styleUrl: './form-input-text-group.component.scss',
  encapsulation: ViewEncapsulation.None,
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => FormInputTextGroupComponent),
      multi: true
    }
  ]
})
export class FormInputTextGroupComponent implements OnInit, ControlValueAccessor {
  @Input() decimals: number = 2;
  @Input() field: string;
  @Input() formControl: FormControl;
  @Input() label: string;
  @Input() number: boolean;
  @Input() placeholder: string;
  @Input() post: string;
  @Input() postIcon: string;
  @Input() pre: string;
  @Input() preIcon: string;

  public id: string;

  public onChange = (_: any) => {
  };
  public onTouch = () => {
  };

  constructor() {
  }

  ngOnInit(): void {
    this.id = `${this.field}-${moment().unix()}`;
  }

  // value accessor functions
  writeValue(): void {
  }

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouch = fn;
  }

  // function to catch input changes and update form in parent
  public onInput($event: any): void {
    this.onTouch();
    this.onChange(this.number ? $event : $event?.target['value']);
  }
}
